import { Edit } from 'react-admin';
import { PriceForm } from './Price.Form';

export const PriceEdit = () => {
    return (
        <Edit>
            <PriceForm />
        </Edit>
    );
};
